<template>
  <div>
    <el-drawer @reload="$reloadHandle"
               title="网点申诉" size="30%"
               :before-close="handleClose"
               :visible.sync="drawer"
               append-to-body ="ture"
               direction="rtl"
               :modal-append-to-body="true"
               custom-class="demo-drawer"
               ref="drawer"
    >
      <div class="demo-drawer__content">
        <div id="containt">
          <div class="tab-box">
            <el-form ref="editForm" :model="formData">
              <el-form-item label="是否申诉" :prop="checkType" >
                <el-select v-model="formData.checkType" style="width: 8vw;"   ref ="checkType" clearable filterable>
                  <el-option label="放弃申诉" :value="0"/>
                  <el-option label="申诉" :value="1"/>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

      <div class="demo-drawer__content">
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="siteAppeal">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import api from "@/api/projectApi";

export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'confirmNo', 'dataId','wf'],
  created() {
    console.log(this.wf)
    this.formData.id = this.dataId
    if(this.wf){
      this.formData.processId = this.wf.processId
      this.formData.messageContent = this.wf.messageContent
      this.formData.id = this.wf.orderId
    }
  },
  data() {
    return {
      uploadFileUrl: api.uploadFileUrl,
      formData: {
        remark: null,
        id: null
      },
      showOrderPop: false,

      drawer: true,


    }
  },
  methods: {
    // 考核的确认
    siteAppeal() {
      this.$http({
        url: "/basic/sfCheckBill/siteAppeal",
        method: 'post',
        data: this.formData
      }).then(res => {
        this.$message.success('确认成功')
        this.$emit('closeD')
        this.$emit('flushed')
      })
    },



    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD', false)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
